module.exports = __webpack_public_path__ + "media/images/favicon-7136f62f379e4c31bcec3c4724101017.ico";